/* PDP buy block — trust pair + highlights panel, inserted under Add to cart.

   Inserted from script rather than written into the template because
   templates/product.json is 75KB, past the size the Admin API can rewrite. The
   theme also morphs the whole product form on every variant change, which takes
   this block with it, so place() re-runs rather than placing once.

   Copy lives in TRUST and POINTS below — those are the only lines to edit for
   wording changes. Styling is in assets/suti-buyblock.css.

   A template can override all of this by including blocks/suti-buy-points.liquid,
   which renders the same markup from editable settings. When that block is on the
   page this script places nothing, so the two can never both appear. */
(function () {
  'use strict';

  /* Written as HTML: an ampersand here has to be &amp;. The POINTS strings
     below are plain text and get escaped by esc(). */
  var TRUST = 'Fast shipping within 24 hours';

  var ICON = {
    /* magnet ring — snap */
    snap: '<circle cx="12" cy="12" r="7.6"/><circle cx="12" cy="12" r="2.9"/>',
    /* ring with an upward arrow — upgraded */
    upgrade: '<circle cx="12" cy="12" r="7.6"/><path d="M12 15.6V8.7M9.2 11.5 12 8.6l2.8 2.9"/>',
    /* phone with a camera — cut per model */
    phone: '<rect x="7" y="3.4" width="10" height="17.2" rx="2.3"/><circle cx="10.4" cy="7.3" r="1.15"/>',
    /* shield with a tick — risk free */
    shield: '<path d="M12 3.6 18.4 6v5.2c0 3.9-2.6 7.2-6.4 8.4-3.8-1.2-6.4-4.5-6.4-8.4V6z"/><path d="m9.3 12.1 1.9 1.9 3.6-3.7"/>'
  };

  var POINTS = [
    ['snap', 'Snaps On, Stays On', 'Strong magnets, no tension. Always in place.'],
    ['upgrade', 'MagSafe, Upgraded', 'PerfectLock™ holds tighter than native MagSafe.'],
    ['phone', 'Cut To Your iPhone', 'Tooled per model. Every cutout lines up exactly.'],
    ['shield', 'Try It Risk-Free', '1-year warranty. Not for you? Send it back.']
  ];

  var svg = function (name) {
    return '<svg class="suti-buy__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor"' +
      ' stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      ICON[name] + '</svg>';
  };

  var esc = function (s) {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  };

  var HTML =
    '<div class="suti-buy__trust">' +
      '<p class="suti-buy__trust-item">' + TRUST + '</p>' +
      '<p class="suti-buy__trust-item">' +
        '<span class="suti-buy__stars" aria-label="5 out of 5 stars">★★★★★</span>' +
        '70k+ happy customers' +
      '</p>' +
    '</div>' +
    '<ul class="suti-buy__points">' +
      POINTS.map(function (p) {
        return '<li class="suti-buy__point">' + svg(p[0]) +
          '<span><span class="suti-buy__point-title">' + esc(p[1]) + '</span>' +
          '<span class="suti-buy__point-desc">' + esc(p[2]) + '</span></span></li>';
      }).join('') +
    '</ul>';

  function place() {
    var main = document.getElementById('MainContent');
    if (!main) return;

    /* This template supplies its own editable buy points — leave it alone. */
    if (main.querySelector('.suti-buy[data-suti-buy-static]')) return;

    var form = main.querySelector('product-form-component');
    if (!form || !form.parentNode) return;
    if (form.parentNode.querySelector('.suti-buy')) return;

    var block = document.createElement('div');
    block.className = 'suti-buy';
    block.innerHTML = HTML;
    form.insertAdjacentElement('afterend', block);
  }

  place();

  /* Coalesced to one check per frame. This PDP morphs 3.4MB of markup on a
     variant change and an uncoalesced observer here would run thousands of
     times during it — the same mistake that once made the hero image take 25
     seconds. The callback is a single querySelector and nothing else. */
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      place();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
